/* eslint-disable @khan/frontend/require-stories -- TODO */
// eslint-disable-next-line no-restricted-imports -- TODO
import * as Perseus from "@khanacademy/perseus";
import type {PropsFor} from "@khanacademy/wonder-blocks-core";

import {perseusStrings} from "../perseus-strings-lingui.tsx";

import {PerseusI18nProviderWrapper} from "./perseus-i18n-provider-wrapper.tsx";

export const HintsRenderer = (
    props: Omit<PropsFor<typeof Perseus.HintsRenderer>, "strings">,
) => (
    <PerseusI18nProviderWrapper>
        <Perseus.HintsRenderer {...props} strings={perseusStrings()} />
    </PerseusI18nProviderWrapper>
);
